<template>
    <div>
        <div class="pos kzgmain">
            <b> 您的位置：</b>
            <a href="/" title="首页"> 首页 </a><span> &gt; </span>
            <i>
                <router-link :to="{ path: '/HzContact', query: { id: id, name: name } }">{{ name }}
                    <!-- <span> &gt; </span> -->
                </router-link>
            </i>
        </div>
        <div class="abo3 kzgmain">
            <h2 class="main_title wow fadeInDown2 animate__animated">
                <a title="联系我们"><strong>联系我们</strong><span>contact us</span></a>
            </h2>
            <ul>
                <li>
                    <em>公司地址</em><i>济南市历城区华龙路1825号嘉恒商务大厦B座803室</i>
                </li>
                <li>
                    <em>公司邮箱</em><i>hzzk@hengzhizikong.com</i>
                </li>
                <li>
                    <em>服务热线</em><i>0531-55511916</i>
                </li>
            </ul>
            <img src="../../images/大博科技园位置.png" title="济南市历城区虞山路5567号大博科技园13号楼402">
        </div>
    </div>
</template>

<script>
import http from '../../js/axios'
import router from '../../router'

export default {
    name: 'HzContact',
    components: {
        router
    },
    data() {
        return {
            id: this.$route.query.id,
            name: this.$route.query.name,
            image: '',
            briefList: [],
            honorList: [],
            profile: '',
        };
    },
    computed: {},
    watch: {},
    methods: {
        queryAbout() {
            http.get('/hzAboutUsInfo/aboutUs').then(res => {
                this.briefList = res.data.data.result;
                this.briefList.forEach(item => {
                    if (item.uiTypeId === '关于我们') {
                        this.profile = item.uiContent;
                    }
                })
            })
        },
        queryHonor() {
            http.get('/hzHonorInfo/honor').then(res => {
                this.honorList = res.data.data.result;
                this.honorList.forEach(item => {
                    item.hiPicture = this.image + item.hiPicture;
                })
                console.log(this.honorList);
            })
        }
    },
    created() {
        this.image = http.imageURL;
        this.queryAbout();
        this.queryHonor();
    },
    mounted() {

    }
}
</script>

<style>
@import "../../config/Control.css";
</style>


// WEBPACK FOOTER //
// src/views/about/HzContact.vue